import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import ReviewsService from '../../services/ReviewsService';
import { modelKeys } from '../queries/useModels';

/**
 * Mutation para criar um novo review
 */
export function useCreateReview() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ modelId, score, comment }) =>
      ReviewsService.createReview({ modelId, score, comment }),
    onSuccess: (data, variables) => {
      const { modelId } = variables;

      // Invalidar query de reviews para mostrar novo review
      queryClient.invalidateQueries({
        queryKey: modelKeys.reviews(modelId),
      });

      // Invalidar detalhes da model para atualizar estatísticas de review
      queryClient.invalidateQueries({
        queryKey: modelKeys.info(modelId),
      });

      toast.success('Review enviado com sucesso!');
    },
    onError: (error) => {
      console.error('Erro ao criar review:', error);
      const message = error.response?.data?.error || 'Erro ao enviar review';
      toast.error(message);
    },
  });
}

/**
 * Mutation para atualizar visibilidade de um review
 */
export function useUpdateReview() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, modelId, show }) =>
      ReviewsService.updateReview({ clientId, modelId, show }),
    onSuccess: async (_data, variables) => {
      const { modelId } = variables;

      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [...modelKeys.all, 'reviews', modelId],
        }),
        queryClient.invalidateQueries({
          queryKey: modelKeys.info(modelId),
        }),
      ]);

      toast.success('Review atualizado com sucesso!');
    },
    onError: (error) => {
      console.error('Erro ao atualizar review:', error);
      const message = error.response?.data?.error || 'Erro ao atualizar review';
      toast.error(message);
    },
  });
}
